import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { betReplayService } from '../../../services/betReplayService';

import { loadingStore } from '../../../store/loadingStore';
import { jackPotStore } from '../../../store/jackPotStore';
import { userInfoStore } from '../../../store/userInfoStore';
import { applicationStore } from '../../../store/applicationStore';

import { gameResources } from '../../../core/resources';
import { parseQuery } from '../../../core/helpers/parseQuery';
import { RtlLanguages } from '../../../core/constants/rtlLanguages';
import { loadResources } from '../../../core/helpers/loadResources';
import { DefaultQueryParams } from '../../../core/constants/defaultQueryParams';
import { AppDefaultValuesEnum } from '../../../core/constants/appDefaultValues';
import { gameDefaultTranslations } from '../../../core/constants/gameDefaultTranslations';

import { soundOptions } from '../../../services/soundService';
import { connectionGroup } from '../../../services/socketConnection';
import { translationService } from '../../../services/translationService';

import LoadingContent from '../../common/loadingContent';
import { TranslationContext } from '../../../contexts/translation';

export let translations = {};

const Loading = observer(({ children }) => {
  const { hasJackPot } = jackPotStore;
  const { isReplay } = userInfoStore;
  const { setTranslationsTextInCanvas } = applicationStore;
  const { isAllResourceLoaded, setIsTranslationsLoaded, setIsGameResourceLoaded } = loadingStore;
  const query = parseQuery(window.location.search);
  const lang = query[DefaultQueryParams.Culture] || AppDefaultValuesEnum.LANGUAGE;
  const partnerId = query[DefaultQueryParams.PartnerId];

  const fetchTranslation = useCallback(async () => {
    if (RtlLanguages.includes(lang)) {
      document.documentElement.setAttribute('dir', 'rtl');
    }
    translationService
      .getTranslations({
        applicationId: AppDefaultValuesEnum.APPLICATION_ID,
        code: lang,
        partnerId,
      })
      .then((res) => {
        translations = Object.keys(res).length ? res : gameDefaultTranslations;
        setTranslationsTextInCanvas(translations);
        setIsTranslationsLoaded(true);
      })
      .catch(() => {
        translations = gameDefaultTranslations;
        setTranslationsTextInCanvas(translations);
        setIsTranslationsLoaded(true);
      });
  }, [lang, partnerId, setTranslationsTextInCanvas, setIsTranslationsLoaded]);

  useEffect(() => {
    fetchTranslation().then();
  }, [fetchTranslation]);

  useEffect(() => {
    loadResources([...gameResources, ...soundOptions])
      .then(() => {
        setIsGameResourceLoaded(true);
        if (!isReplay) {
          connectionGroup.startGameConnection().then(() => {});
        } else {
          betReplayService.getBetReplayData();
        }
      })
      .catch((error) => {
        console.error('error !!', error);
      });
  }, [setIsGameResourceLoaded, isReplay]);

  useEffect(() => {
    if (hasJackPot) {
      connectionGroup.startJackpotConnection();
    }
  }, [hasJackPot]);

  return (
    <TranslationContext.Provider value={translations}>
      {isAllResourceLoaded ? children : <LoadingContent />}
    </TranslationContext.Provider>
  );
});

export default Loading;
